import{a as r}from"./chunk-BQHFCOBF.js";import{useQuery as t}from"@tanstack/react-query";import{getUserSettings as n}from"@sbu/services.shared";var a=({userSettingsList:e},s)=>t(r({queryKey:["userPreferences",e],queryFn:()=>n({userSettingsList:e})},s));export{a as useUserPreferences};
//# sourceMappingURL=index.js.map
